import { Type } from "../Type";
export function islyUndefined(name) {
    return new IslyUndefined(name ?? "undefined");
}
export class IslyUndefined extends Type {
    class = "undefined";
    is = (value) => value === undefined;
}
//# sourceMappingURL=index.js.map